import algoliasearch from 'algoliasearch';
import once from 'lodash-es/once';

export interface AlgoliaConfig {
  algoliaEnv: string;
  apiKey: string;
  appId: string;
  url?: string;
}

export const getAlgoliaClient = once(
  ({ apiKey, appId, url }: Omit<AlgoliaConfig, 'algoliaEnv'>) => {
    return algoliasearch(appId, apiKey, {
      /**
       * @see https://www.algolia.com/doc/api-reference/api-methods/configuring-timeouts/?client=javascript
       * Becomes milliseconds in v5.
       */
      timeouts: {
        /**
         * Connection timeout in seconds.
         * @default 2
         */
        connect: 4,
        /**
         * Read timeout in seconds.
         * @default 5
         */
        read: 5,
        /**
         * Write timeout in seconds.
         * @default 30
         */
        write: 30,
      },
      ...(url ? { hosts: [{ url }] } : {}),
    });
  }
);
